import { NavLink, Outlet, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useLocation } from "react-router-dom";

import { styled } from '@mui/joy/styles';
import Sheet from '@mui/joy/Sheet';
import Grid from '@mui/joy/Grid';
import Box from '@mui/joy/Box';

import Stack from '@mui/joy/Stack';
import IconButton from '@mui/joy/IconButton';

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';


import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemDecorator, {
    listItemDecoratorClasses,
} from '@mui/joy/ListItemDecorator';
import ListItemContent from '@mui/joy/ListItemContent';
import ListItemButton from '@mui/joy/ListItemButton';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';


import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';


import { useTranslation } from 'react-i18next';

import { getHeaderConfig, clearAuthInfo } from '../Api/utils';



///////////// Images
import LogoImage from '../assets/logo.svg';
import DashboardImage from '../assets/icons/Dashboard.svg';
import WebsiteImage from '../assets/icons/Website.svg';
import CarImage from '../assets/icons/Car.svg';
import ReportsImage from '../assets/icons/Reports.svg';
import UsersImage from '../assets/icons/Users.svg';
import OffersImage from '../assets/icons/Offers.svg';
import ClientsImage from '../assets/icons/Clients-icon.svg';



//////////////////// Images
import LogoutIcon from '../assets/icons/logoutIcon.svg'


/////////////////// API
import { getNotifications } from '../Api/Notifications';


const urls = {
    "/": 0,
    "/website-homepage": 2,
    "/website-our-services": 3,
    "/website-statistics-number": 4,
    "/website-ads": 5,
    "/website/news": 6,
    "/website/FAQ": 7,
    "/website/descount": 8,
    "/website/static-pages": 9,
    "/website/contactUs": 10,
    "/clients": 11,
    "/cars": 12,
    "/cars/add-new-model": 16,
    "/reports": 13,
    "/users": 14,
    "/offers": 15,
    "/OrderPricing": 17,
    "/OtherOrders": 18,
}





export default function MainLayout() {
    const { pathname } = useLocation();
    const [breadcrumbsPath, setBreadcrumbsPath] = useState([])
    const { t, i18n } = useTranslation();
    

      const [notifications, setNotifications] = useState([])
    
    
      const listNotifications = useCallback (async () => {
        const res = await getNotifications()
        if(res) {
          setNotifications(res)
        }
      },[pathname])
      
      
      useEffect(() => {
        listNotifications()
      }, [listNotifications])


    const getDefaultURL = () => {
        const isDynamicUrl = ["cars/imitation-model", "cars/edit-model"].some(dynamicPath => pathname.includes(dynamicPath))
        if (isDynamicUrl) {
            return 99999
        }
        const match = urls[pathname]
        return match ?? 0
    }


    const [index, setIndex] = useState(getDefaultURL());
    const [openSubMenu, setOpenSubMenu] = useState(false);
    const [roleId, setRoleId] = useState([])
    const [adminType, setAdminType] = useState(null)

    const navigate = useNavigate();
    const changeLang = (lang) => {
        i18n.changeLanguage(lang)
    };

    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }

    const logOutAction = () => {
        localStorage.setItem("adminRoleSoomha", null);
        localStorage.setItem("typeAdminSoomha", null);

        clearAuthInfo();
        navigate('/')
        window.location.reload(true);
    }

    const getRoleAamin = useCallback(async () => {
        let role = await JSON.parse(localStorage.getItem("adminRoleSoomha"));
        let typeAdmin = await JSON.parse(localStorage.getItem("typeAdminSoomha"));
        let roles = role.map((roleIds) => {
            return roleIds.role_id
        })
        let numberArray = roles.map(Number);
        setRoleId(numberArray)
        setAdminType(typeAdmin)
    }, [])



    useEffect(() => {
        getRoleAamin()
    }, [getRoleAamin])



    useEffect(() => {
        const urlMatch = Object.entries(urls).find(([, value]) => value === index)
        if (urlMatch) {
            navigate(urlMatch.at(0))
        }
    }, [index]);

    useEffect(() => {
        if (pathname == '/') {
            setBreadcrumbsPath(["لوحة التحكم"])
        } else if (pathname == '/clients') {
            setBreadcrumbsPath(["العملاء"])
        } else if (pathname == '/cars') {
            setBreadcrumbsPath(["السيارات"])
        } else if (pathname == '/offers') {
            setBreadcrumbsPath(["عروض تقييم السيارات"])
        } else if (pathname == '/reports') {
            setBreadcrumbsPath(["التقارير"])
        } else if (pathname == '/users') {
            setBreadcrumbsPath(["المستخدمين"])
        } else if (pathname == '/website-homepage') {
            setBreadcrumbsPath([" الموقع الإلكتروني", "الرئيسية"])
        } else if (pathname == '/website-our-services') {
            setBreadcrumbsPath([" الموقع الإلكتروني", "خدماتنا"])
        } else if (pathname == '/website-statistics-number') {
            setBreadcrumbsPath([" الموقع الإلكتروني", "سومها بالارقام"])
        } else if (pathname == '/website-ads') {
            setBreadcrumbsPath([" الموقع الإلكتروني", "الإعلانات"])
        } else if (pathname == '/website/news') {
            setBreadcrumbsPath([" الموقع الإلكتروني", "الأخبار و الأحداث"])
        } else if (pathname == '/website/FAQ') {
            setBreadcrumbsPath([" الموقع الإلكتروني", "الأسئلة الشائعة"])
        } else if (pathname == '/website/descount') {
            setBreadcrumbsPath([" الموقع الإلكتروني", "أكواد الخصومات"])
        } else if (pathname == '/website/static-pages') {
            setBreadcrumbsPath([" الموقع الإلكتروني", "الصفحات المثبتة"])
        } else if (pathname == '/website/contactUs') {
            setBreadcrumbsPath([" الموقع الإلكتروني", "تواصل معنا"])
        } else if (pathname == '/OrderPricing') {
            setBreadcrumbsPath(["الطلبات"])
        } else if (pathname == '/OtherOrders') {
            setBreadcrumbsPath(["طلبات اضافة موديل"])
        }else if (pathname == '/notifications') {
            setBreadcrumbsPath(["الاشعارات"])
        }

        
    }, [pathname])


    const openNotification = () => {
        navigate('/notifications')
    }

    return (
        <Grid container spacing={2} sx={{ flexGrow: 1 }}>

            <Grid xs={3} md={3} sx={{ textAlign: 'center', backgroundColor: 'rgba(33, 150, 243, 0.05)', height: '100%', direction: 'rtl', padding: '50px 3%', overflow: 'scroll' }}>
                <img src={LogoImage} alt="logo" />
                <Box sx={{ width: '100%' }}>
                    <List
                        aria-label="Sidebar"
                        sx={{
                            '--ListItem-paddingLeft': '0px',
                            '--ListItemDecorator-size': '64px',
                            '--ListItem-minHeight': '32px',
                            '--List-nestedInsetStart': '13px',
                            [`& .${listItemDecoratorClasses.root}`]: {
                                justifyContent: 'flex-end',
                                pr: '18px',
                            },
                            '& [role="button"]': {
                                borderRadius: '20px',
                            },

                        }}
                    >
                        <ListItem sx={{ marginBottom: '10px' }}>
                            <ListItemButton
                                selected={index === 0}
                                // color={index === 0 ? 'primary' : undefined}
                                onClick={() => setIndex(0)}
                                sx={{ color: index === 0 ? '#FFF' : '#86878A', backgroundColor: index === 0 ? '#1F327A !important' : '' }}                            >
                                <ListItemDecorator sx={{ marginLeft: '15px' }}>
                                    <img src={DashboardImage} alt="icon" />
                                </ListItemDecorator>
                                <ListItemContent>لوحة التحكم</ListItemContent>
                                {/* <Typography
                                    level="body-sm"
                                    sx={{ fontWeight: 'bold', color: 'inherit' }}
                                >
                                    1,950
                                </Typography> */}
                            </ListItemButton>
                        </ListItem>

                        <ListItem nested>
                            <ListItemButton
                                selected={index === 1 || index === 7}
                                // color={index === 1 ? 'success' : undefined}
                                onClick={() => { setOpenSubMenu(!openSubMenu) }}
                                sx={{ color: index === 1 ? '#FFF' : '#86878A', backgroundColor: index === 1 ? '#1F327A !important' : '' }}                            >
                                <ListItemDecorator sx={{ marginLeft: '15px' }}>
                                    {openSubMenu ? (
                                        <ArrowDropDown fontSize="lg" />
                                    ) : (
                                        <ArrowLeftIcon fontSize="lg" />
                                    )}
                                    <img src={WebsiteImage} alt="icon" />
                                </ListItemDecorator>
                                الموقع الإلكتروني
                            </ListItemButton>
                            {openSubMenu ? (
                                <List>
                                    {adminType == 0 ? (
                                        <ListItem>
                                            <ListItemButton
                                                selected={index === 2}
                                                // color={index === 2 ? 'primary' : undefined}
                                                onClick={() => setIndex(2)}
                                                sx={{ color: index === 2 ? '#FFF' : '#86878A', backgroundColor: index === 2 ? '#1F327A !important' : '' }}
                                            >
                                                <ListItemDecorator>
                                                    {/* <People fontSize="lg" /> */}
                                                </ListItemDecorator>
                                                <ListItemContent>الرئيسية</ListItemContent>
                                                {/* <Typography level="body-sm">4,320</Typography> */}
                                            </ListItemButton>
                                        </ListItem>
                                    ) : null}

                                    {adminType == 0 ? (
                                        <ListItem>
                                            <ListItemButton
                                                selected={index === 3}
                                                onClick={() => setIndex(3)}
                                                sx={{ color: index == '3' ? '#FFF' : '#86878A', backgroundColor: index == '3' ? '#1F327A !important' : '' }}
                                            >
                                                <ListItemDecorator>
                                                    {/* <People fontSize="lg" /> */}
                                                </ListItemDecorator>
                                                <ListItemContent>خدماتنا</ListItemContent>
                                                {/* <Typography level="body-sm">22,252</Typography> */}
                                            </ListItemButton>
                                        </ListItem>
                                    ) : null}
                                    {adminType == 0 ? (
                                        <ListItem>
                                            <ListItemButton
                                                selected={index === 4}
                                                // color={index === 4 ? 'warning' : undefined}
                                                onClick={() => setIndex(4)}
                                                sx={{ color: index === 4 ? '#FFF' : '#86878A', backgroundColor: index === 4 ? '#1F327A !important' : '' }}                                    >
                                                <ListItemDecorator>
                                                    {/* <People fontSize="lg" /> */}
                                                </ListItemDecorator>
                                                <ListItemContent>سومها بالارقام</ListItemContent>
                                                {/* <Typography level="body-sm">22,252</Typography> */}
                                            </ListItemButton>
                                        </ListItem>
                                    ) : null}
                                    {(adminType == 0 || roleId.includes(1) || roleId.includes(2)) ? (
                                        <ListItem>
                                            <ListItemButton
                                                selected={index === 5}
                                                // color={index === 5 ? 'warning' : undefined}
                                                onClick={() => setIndex(5)}
                                                sx={{ color: index === 5 ? '#FFF' : '#86878A', backgroundColor: index === 5 ? '#1F327A !important' : '' }}                                    >
                                                <ListItemDecorator>
                                                    {/* <People fontSize="lg" /> */}
                                                </ListItemDecorator>
                                                <ListItemContent>الإعلانات</ListItemContent>
                                                {/* <Typography level="body-sm">22,252</Typography> */}
                                            </ListItemButton>
                                        </ListItem>
                                    ) : null}

                                    {adminType == 0 ? (
                                        <ListItem>
                                            <ListItemButton
                                                selected={index === 6}
                                                // color={index === 6 ? 'warning' : undefined}
                                                onClick={() => setIndex(6)}
                                                sx={{ color: index === 6 ? '#FFF' : '#86878A', backgroundColor: index === 6 ? '#1F327A !important' : '' }}                                    >
                                                <ListItemDecorator>

                                                </ListItemDecorator>
                                                <ListItemContent>الأخبار و الأحداث</ListItemContent>

                                            </ListItemButton>
                                        </ListItem>
                                    ) : null}
                                    {adminType == 0 ? (
                                        <ListItem>
                                            <ListItemButton
                                                selected={index === 7}
                                                // color={index === 7 ? 'warning' : undefined}
                                                onClick={() => setIndex(7)}
                                                sx={{ color: index === 7 ? '#FFF' : '#86878A', backgroundColor: index === 7 ? '#1F327A !important' : '' }}                                    >
                                                <ListItemDecorator>
                                                    {/* <People fontSize="lg" /> */}
                                                </ListItemDecorator>
                                                <ListItemContent>الأسئلة الشائعة</ListItemContent>
                                                {/* <Typography level="body-sm">22,252</Typography> */}
                                            </ListItemButton>
                                        </ListItem>
                                    ) : null}

                                    {adminType == 0 ? (
                                        <ListItem>
                                            <ListItemButton
                                                selected={index === 8}
                                                // color={index === 8 ? 'warning' : undefined}
                                                onClick={() => setIndex(8)}
                                                sx={{ color: index === 8 ? '#FFF' : '#86878A', backgroundColor: index === 8 ? '#1F327A !important' : '' }}                                    >
                                                <ListItemDecorator>
                                                    {/* <People fontSize="lg" /> */}
                                                </ListItemDecorator>
                                                <ListItemContent>أكواد الخصومات</ListItemContent>
                                                {/* <Typography level="body-sm">22,252</Typography> */}
                                            </ListItemButton>
                                        </ListItem>
                                    ) : null}
                                    {adminType == 0 ? (
                                        <ListItem>
                                            <ListItemButton
                                                selected={index === 9}
                                                // color={index === 9 ? 'primary' : undefined}
                                                onClick={() => setIndex(9)}
                                                sx={{ color: index === 9 ? '#FFF' : '#86878A', backgroundColor: index === 9 ? '#1F327A !important' : '' }}                                    >
                                                <ListItemDecorator>
                                                    {/* <People fontSize="lg" /> */}
                                                </ListItemDecorator>
                                                <ListItemContent>الصفحات المثبتة</ListItemContent>
                                                {/* <Typography level="body-sm">22,252</Typography> */}
                                            </ListItemButton>
                                        </ListItem>
                                    ) : null}
                                    {adminType == 0 ? (
                                        <ListItem sx={{ marginBottom: '10px' }}>
                                            <ListItemButton
                                                selected={index === 10}
                                                // color={index === 10 ? 'neutral' : undefined}
                                                onClick={() => setIndex(10)}
                                                sx={{ color: index === 10 ? '#FFF' : '#86878A', backgroundColor: index === 10 ? '#1F327A !important' : '' }}                            >
                                                <ListItemDecorator>
                                                    {/* <img src={OffersImage} alt="icon" /> */}
                                                </ListItemDecorator>
                                                <ListItemContent>تواصل معنا</ListItemContent>
                                            </ListItemButton>
                                        </ListItem>
                                    ) : null}
                                </List>
                            ) : false}
                        </ListItem>

                        {adminType == 0 ? (
                            <ListItem sx={{ marginBottom: '10px' }}>
                                <ListItemButton
                                    selected={index === 11}
                                    // color={index === 10 ? 'neutral' : undefined}
                                    onClick={() => setIndex(11)}
                                    sx={{ color: index === 11 ? '#FFF' : '#86878A', backgroundColor: index === 11 ? '#1F327A !important' : '' }}                            >
                                    <ListItemDecorator sx={{ marginLeft: '15px' }}>
                                        <img src={ClientsImage} alt="icon" />
                                    </ListItemDecorator>
                                    <ListItemContent>العملاء</ListItemContent>
                                </ListItemButton>
                            </ListItem>
                        ) : null}

                        {(adminType == 0 || roleId.includes(3) || roleId.includes(4)) ? (
                            <ListItem sx={{ marginBottom: '10px' }}>
                                <ListItemButton
                                    selected={index === 12}
                                    // color={index === 12 ? 'neutral' : undefined}
                                    onClick={() => setIndex(12)}
                                    sx={{ color: index === 12 ? '#FFF' : '#86878A', backgroundColor: index === 12 ? '#1F327A !important' : '' }}                            >
                                    <ListItemDecorator sx={{ marginLeft: '15px' }}>
                                        <img src={CarImage} alt="icon" />
                                    </ListItemDecorator>
                                    <ListItemContent>السيارات</ListItemContent>
                                </ListItemButton>
                            </ListItem>
                        ) : null}
                        {(adminType == 0 || roleId.includes(5)) ? (
                            <ListItem sx={{ marginBottom: '10px' }}>
                                <ListItemButton
                                    selected={index === 13}
                                    // color={index === 13 ? 'neutral' : undefined}
                                    onClick={() => setIndex(13)}
                                    sx={{ color: index === 13 ? '#FFF' : '#86878A', backgroundColor: index === 13 ? '#1F327A !important' : '' }}                            >
                                    <ListItemDecorator sx={{ marginLeft: '15px' }}>
                                        <img src={ReportsImage} alt="icon" />
                                    </ListItemDecorator>
                                    <ListItemContent>التقارير</ListItemContent>
                                </ListItemButton>
                            </ListItem>
                        ) : null}
                        {adminType == 0 ? (
                            <ListItem sx={{ marginBottom: '10px' }}>
                                <ListItemButton
                                    selected={index === 14}
                                    // color={index === 14 ? 'neutral' : undefined}
                                    onClick={() => setIndex(14)}
                                    sx={{ color: index === 14 ? '#FFF' : '#86878A', backgroundColor: index === 14 ? '#1F327A !important' : '' }}                            >
                                    <ListItemDecorator sx={{ marginLeft: '15px' }}>
                                        <img src={UsersImage} alt="icon" />
                                    </ListItemDecorator>
                                    <ListItemContent>المستخدمين</ListItemContent>
                                </ListItemButton>
                            </ListItem>
                        ) : null}

                        {adminType == 0 ? (
                            <ListItem sx={{ marginBottom: '10px' }}>
                                <ListItemButton
                                    selected={index === 15}
                                    // color={index === 15 ? 'neutral' : undefined}
                                    onClick={() => setIndex(15)}
                                    sx={{ color: index === 15 ? '#FFF' : '#86878A', backgroundColor: index === 15 ? '#1F327A !important' : '' }}                            >
                                    <ListItemDecorator sx={{ marginLeft: '15px' }}>
                                        <img src={OffersImage} alt="icon" />
                                    </ListItemDecorator>
                                    <ListItemContent>باقات تقييم السيارات</ListItemContent>
                                </ListItemButton>
                            </ListItem>
                        ) : null}

                        {adminType == 0 ? (
                            <ListItem sx={{ marginBottom: '10px' }}>
                                <ListItemButton
                                    selected={index === 17}
                                    // color={index === 17 ? 'neutral' : undefined}
                                    onClick={() => setIndex(17)}
                                    sx={{ color: index === 17 ? '#FFF' : '#86878A', backgroundColor: index === 17 ? '#1F327A !important' : '' }}                            >
                                    <ListItemDecorator sx={{ marginLeft: '15px' }}>
                                        <img src={OffersImage} alt="icon" />
                                    </ListItemDecorator>
                                    <ListItemContent>طلبات التقيم الذاتى</ListItemContent>
                                </ListItemButton>
                            </ListItem>
                        ) : null}

                        {adminType == 0 ? (
                            <ListItem sx={{ marginBottom: '10px' }}>
                                <ListItemButton
                                    selected={index === 18}
                                    // color={index === 18 ? 'neutral' : undefined}
                                    onClick={() => setIndex(18)}
                                    sx={{ color: index === 18 ? '#FFF' : '#86878A', backgroundColor: index === 18 ? '#1F327A !important' : '' }}                            >
                                    <ListItemDecorator sx={{ marginLeft: '15px' }}>
                                        <img src={OffersImage} alt="icon" />
                                    </ListItemDecorator>
                                    <ListItemContent>طلبات اضافة موديل</ListItemContent>
                                </ListItemButton>
                            </ListItem>
                        ) : null}


                    </List>
                </Box>
                {/* <nav>
                    <h1>Layout</h1>

                </nav> */}
            </Grid>
            {/* {breadcrumbsPath[0]}
            {breadcrumbsPath.length} */}

            <Grid container xs={12} md={9} sx={{ padding: '50px 3% 100px 3%' }}>
                <Box sx={{ width: '100%' }}>
                    <Stack spacing={2}>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', paddingBottom: '50px' }}>
                            <div role="presentation" onClick={handleClick}>

                                {breadcrumbsPath.length == 2 ? (
                                    <Breadcrumbs aria-label="breadcrumb">
                                        <Link
                                            underline="hover"
                                            color="inherit"
                                            sx={{ color: '#434448', fontSize: '25px', fontWeight: 'bold' }}
                                        // href="/"
                                        >
                                            {breadcrumbsPath[0]}
                                        </Link>
                                        <Typography sx={{ color: '#434448', fontSize: '20px' }}>{breadcrumbsPath[1]}</Typography>
                                    </Breadcrumbs>
                                ) : (
                                    <Breadcrumbs aria-label="breadcrumb">
                                        <Link
                                            underline="hover"
                                            color="inherit"
                                            sx={{ color: '#434448', fontSize: '25px', fontWeight: 'bold' }}
                                        // href="/"
                                        >
                                            {breadcrumbsPath[0]}
                                        </Link>
                                    </Breadcrumbs>
                                )}

                            </div>


                            <Stack spacing={4} direction="row" sx={{ color: 'action.active', cursor:'pointer' }} onClick={openNotification}>
                                <Badge color="secondary" badgeContent={notifications.length}>
                                    <NotificationsIcon />
                                </Badge>
                            </Stack>
                            {/* <Button variant="plain" onClick={logOutAction}>
                                <img src={LogoutIcon} alt="Logout icon" />
                            </Button> */}

                            <IconButton variant="plain" onClick={logOutAction}>
                                <img src={LogoutIcon} alt="Logout icon" />
                            </IconButton>
                        </Box>
                        <Outlet />
                    </Stack>
                </Box>
            </Grid>
        </Grid>
    )
}